<template name="video-chat">
  <div class="video-chat-container" :class="{connected: !loading}">
    <div class="video-chat-focusarea" v-if="onScan">
      <div class="video-chat-focusarea-box">
        <div class="video-chat-focusarea-text">SCANNING</div>
      </div>
    </div>
    <div class="video-chat-direction">
      <img v-if="direction.show" :src="direction.image">
    </div>
    <div class="utilities" id="util">
      <div class="on-record" v-if="onRecord">
        <span class="mdi mdi-record"></span>
      </div>

      <button type="button" class="ut-btn" @click="scanCode">
        <span class="mdi mdi-barcode-scan"></span>
      </button>

      <button type="button" class="ut-btn" @click="sendLocation">
        <span class="mdi mdi-map-check-outline"></span>
      </button>

      <button type="button" class="ut-btn" @click="toggleTorch(!torch)">
        <span v-if="torch" class="mdi mdi-flash-off"></span>
        <span v-else class="mdi mdi-flash"></span>
      </button>

      <button type="button" class="ut-btn" @click="audioMute(!audioMuted)">
        <span v-if="audioMuted" class="mdi mdi-volume-mute"></span>
        <span v-else class="mdi mdi-volume-high"></span>
      </button>

      <button type="button" class="ut-btn" @click="videoMute(!muted)">
        <span v-if="muted" class="mdi mdi-television-play"></span>
        <span v-else class="mdi mdi-television-stop"></span>
      </button>
      
      <button type="button" class="ut-btn" @click="closeApp">
        <span class="mdi mdi-exit-run"></span> 
        <!-- mdi-close-outline -->
      </button>
    </div>

    <button type="button" class="fs_nbh" v-if="!iPhone()" @click="toggleFullScreen()">
      <span class="mdi mdi-fullscreen" id="fs"></span>
    </button>

    <drawboard ref="drawboard" />
    <div class="video-chat-wait">
      <img class="progress-circle" :src="$client.loading" />
      <div class="loading-message">{{loadingMessage}}</div>
    </div>
    <div class="video-chat-online">
      <video ref="remotev" class="video-remote" autoplay playsinline :muted="audioMuted" v-show="remoteVideoEnable" />
      <video ref="localv" class="video-local" :class="vmode" v-show="!onScan" autoplay playsinline muted />
    </div>
    <video ref="readerv" class="video-reader" :class="{'on-scan': onScan, hori: vmode === 'hori', vert: vmode === 'vert'}" playsinline muted />
    <exit-dialog v-model="exitDialog" @submit="exitDialogSubmitHandler">
      상담을 종료하시겠습니까?
    </exit-dialog>
    <div class="ios-dir-assist" v-if="angle">
      <div class="ios-dir-assist-box">
        <span class="mdi mdi-arrow-up-bold" :style="{transform: `rotate(${angle}deg)`}"></span>
        <div class="ios-dir-assist-desc">
          화살표 방향이 위쪽으로 보도록 화면을 회전시켜 주세요.
        </div>
      </div>
    </div>
  </div>
</template>
<!--script src="owt.js" type="text/javascript"></script-->
<script>
//import JsSIP from 'jssip'
import * as Dir from '@/components/DirectionImages'
//import * as Owt from '@/components/owt'
import '../components/sc.websocket.js'
import '../components/owt.js'
import Drawboard from '@/components/Drawboard'
import ExitDialog from '@/components/Dialog'
// import Ice from '@/plugin/server-list'
// JsSIP.debug.enable('JsSIP:*')
//JsSIP.debug.disable('JsSIP:*')

 // Intel WebRTC
//'use strict';
const signaling = new SignalingChannel();
let publicationForCamera;
let publicationForScreen;
var localStream;
var currentCarmeraId = null;
var frontCameraId = null;
var backCameraId = null;

const supports = navigator.mediaDevices.getSupportedConstraints()
const BarcodeFormats = ['AZTEC','CODABAR','CODE_39','CODE_93','CODE_128','DATA_MATRIX','EAN_8','EAN_13','ITF','MAXICODE','PDF_417','QR_CODE','RSS_14','RSS_EXPANDED','UPC_A','UPC_E','UPC_EAN_EXTENSION']
export default {
  components: {Drawboard, ExitDialog},
  methods: {
    iPhone(){
      if(/iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        return true
      }else{
        return false
      }
    }
    ,
    toggleFullScreen() {
          if (!document.fullscreenElement &&    // alternative standard method
          !document.mozFullScreenElement && !document.webkitFullscreenElement) {  // current working methods
          if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen();
          } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
          } else if (document.documentElement.webkitRequestFullscreen) {
            document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
          }

          document.getElementById('fs').className = 'mdi mdi-fullscreen-exit';
        } else {
            if (document.cancelFullScreen) {
              document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
              document.webkitCancelFullScreen();
            }

            document.getElementById('fs').className = 'mdi mdi-fullscreen';
        }
    }
       ,
    // Intel WebRTC
  owt_streamAdded(e) {
    e.stream.addEventListener('ended', () => {
      console.log('Stream is removed.');
      //window.removeEventListener("beforeunload", this.onBeforeUnloadHandler)
      //window.location.href = process.env.BASE_URL
    });
            
    if (e.stream.source.video === 'screen-cast') {
      //this.$refs.remotev.show();
      this.$refs.remotev.srcObject = e.stream.mediaStream;
      this.$refs.remotev.play();
    } else if (e.stream.source.audio || e.stream.source.video) {
      //this.$refs.remotev.show();
      this.$refs.remotev.srcObject = e.stream.mediaStream;
      this.$refs.remotev.play();

      // Audio
      //$('#remoteAudio').get(0).srcObject = e.stream.mediaStream;
      //$('#remoteAudio').get(0).play();
    }
  }, 
  owt_messagereceived(e) {
    console.info('messagereceived : ' + e.message + e.origin)
    if(e.message === 'p') {
      this.owt_publish()
    } else if(e.message === 'p2') {
      this.owt_unPublish()
    }
  },
  owt_serverdisconnected(e) {
    console.info('owt_serverdisconnected')
    window.removeEventListener("beforeunload", this.onBeforeUnloadHandler)
    // window.location.href = process.env.BASE_URL
    if(this.signalingConnect){
      // alert('webRTC signaling서버 연결에 실패하였습니다')
    }else{
      alert('webRTC 화상서버 연결에 실패하였습니다')
      this.$client.close()
      this.$router.replace({name: 'home'})
    }
  },
  owt_init() {
    //const shortkey = this.$route.params.shortkey
    this.owt_Uid = this.$client.shortkey
    //this.owt_remoteUid = this.owt_Uid + "a"
    this.owt_remoteUid = this.owt_Uid + "_s"
    console.info('owt_init / shortkey : ' + this.owt_Uid);

    this.owt_p2p = new Owt.P2P.P2PClient({
      audioEncodings: true,
      videoEncodings: [{
        codec: {
          name: 'h264'
        }
      }, {
          codec: {
          name: 'vp9'
        }
      }, {
          codec: {
          name: 'vp8'
        } 
      }],
      rtcConfiguration: {
        iceServers: [{
            urls: 'stun:13.124.129.77:13478'
          }, {
            urls: ["turn:13.124.129.77:13478?transport=udp",
                  "turn:13.124.129.77:13478?transport=tcp"
                  ],
            credential: "koino",
            username: "koino"
          }]
        },
    }, signaling);

    this.owt_p2p.allowedRemoteIds = [this.owt_remoteUid];
    this.owt_p2p.addEventListener('messagereceived', this.owt_messagereceived.bind(this));
    this.owt_p2p.addEventListener('streamadded', this.owt_streamAdded.bind(this));
    this.owt_p2p.addEventListener('serverdisconnected', this.owt_serverdisconnected.bind(this));    
  },
  owt_connect() { 
    console.log('webrtc connect id : ' + this.owt_Uid);
    this.owt_p2p.connect({
      host: 'https://video.anysupport.net:7002',
      token: this.owt_Uid
    }).then(() => {
      console.log('Succed to connect to the signaling server!!');
      this.loading = false
      this.$refs.drawboard.setVideo(this.$refs.localv)
      this.owt_publish();
    }, error => {
      console.log('Failed to connect to the signaling server. ' + error);
      signalingConnect = true;
    }); // Connect to signaling server.
  },
  async owt_initcamera() {
//nbh
if (this.$ua.os.name === 'iOS'){
    await navigator.mediaDevices.getUserMedia({video:true, audio:true})
}
    let videoDevices = { front: [], back: [] }

    navigator.mediaDevices.enumerateDevices()
    .then((tdevs) => {
      for (let d of tdevs) {
        if (d.kind === 'audioinput') continue;
        if (/front|전면/.test(d.label)) videoDevices.front.unshift(d)
        else if (/back|후면/.test(d.label)) videoDevices.back.unshift(d)
        else console.log(d.label)
      }

      if(videoDevices != null) {
        videoDevices.front.sort((a, b) => {return a.label < b.label ? -1 : a.label > b.label ? 1 : 0})
        videoDevices.back.sort((a, b) => {return a.label < b.label ? -1 : a.label > b.label ? 1 : 0})
        if(videoDevices.front.length > 0) {
          this.frontCameraId = videoDevices.front[0].deviceId;
        }
        if(videoDevices.back.length > 0) {
          this.backCameraId = videoDevices.back[0].deviceId;
          this.currentCarmeraId = this.backCameraId;
        }
      }
      console.log('owt_initcamera!!!');
      //this.owt_connect();
      
    });

    
  },
  async owt_publish(wid,hei) {
    //this.setUserMedia()
    if (this.localStream) {
      this.owt_p2p.publish(this.owt_remoteUid, this.localStream).then(publication => {
        publicationForCamera = publication;
      }, error => {
        console.log('Failed to share video!!!');
      }); // Publish local stream to remote client
    } else {
      window.localv = this.$refs.localv

      const audioConstraintsForMic = new Owt.Base.AudioTrackConstraints(Owt.Base.AudioSourceInfo.MIC);
      var videoConstraintsForCamera = new Owt.Base.VideoTrackConstraints(Owt.Base.VideoSourceInfo.CAMERA);

      if(this.backCameraId != null  && this.currentCarmeraId === this.backCameraId) {
        videoConstraintsForCamera.deviceId = this.backCameraId;
      }
      if(this.frontCameraId != null  && this.currentCarmeraId == this.frontCameraId) {
        videoConstraintsForCamera.deviceId = this.frontCameraId;
      }

      // 테스트
      var owtresolution =  new Owt.Base.Resolution();
      owtresolution.width = wid;
      owtresolution.height = hei;
      videoConstraintsForCamera.resolution = owtresolution
      //videoConstraintsForCamera.resolution.height = 720
      videoConstraintsForCamera.frameRate = 16
      /***/

      let mediaStream;
      Owt.Base.MediaStreamFactory.createMediaStream(new Owt.Base.StreamConstraints(audioConstraintsForMic, videoConstraintsForCamera)).then(stream => {
        mediaStream = stream;
        this.localStream = new Owt.Base.LocalStream(mediaStream, new Owt.Base.StreamSourceInfo('mic', 'camera'));

        let videoTracks = this.localStream.mediaStream.getVideoTracks()
        this.mediaInfo = videoTracks[0].getSettings()
        this.capabilities = videoTracks[0].getCapabilities()
        this.videoTrack = videoTracks[0]

        this.$refs.localv.srcObject = this.localStream.mediaStream;
        //this.owt_p2p.allowedRemoteIds = [this.owt_remoteUid];
        this.owt_p2p.publish(this.owt_remoteUid, this.localStream).then(publication => {
          publicationForCamera = publication;
        }, error => {
          console.log('Failed to share video. ' + error);
        });
      }, err => {
        console.error('Failed to create MediaStream, ' + err);
      });
    }
  },
  owt_unPublish() {
    // publicationForCamera.stop();
    for (const track of this.localStream.mediaStream.getTracks()) {
      track.stop();
    }
    this.localStream = undefined;
  },
  owt_stop() {
    this.owt_p2p.stop();
  },
  owt_sendData(data) {
    this.$client.send(data);
    //this.owt_p2p.send(this.owt_remoteUid, JSON.stringify(data));
  },
  connect () {
      this.loading = true
      // return;

      let socket = new JsSIP.WebSocketInterface(process.env.VUE_APP_SIP_WSS)
      let configuration = {
        sockets  : [ socket ],
        uri      : `sip:${this.sip_id}@${process.env.VUE_APP_SIP_SERVER}`
      }

      this.ua = new JsSIP.UA(configuration)

      this.ua.on('connected', () => { this.loadingMessage = '화상서버에 연결되었습니다' })
      this.ua.on('disconnected', () => this.exitProgress('화상서버에 연결에 실패하였습니다'))
      this.ua.on('registered', this.callAgent.bind(this))
      this.ua.on('unregistered', () => { console.log('unregistered') })
      this.ua.on('registrationFailed', () => this.exitProgress('세션등록에 실패하였습니다'))
      // this.ua.on('newRTCSession', (data, a) => {
      //   console.log('[newRTCSession]')
      //   console.log(data)
      //   console.log(a)
      // })

      this.ua.start()
    },
    callAgent () {
      /*async
      let deviceId = this.camera.back; // 2020.03.27 mwj204
      let stream = await navigator.mediaDevices.getUserMedia({video: {deviceId}})*/

      console.log('[CALLAGENT]')
      var options = {
        'mediaConstraints' : {
          'audio': true,
          // 'video': Object.assign(this.qualities[1], { facingMode: this.facingMode })
          'video': {
            // width: 1280, height: 640,
            // facingMode: this.facingMode,
            // focusmode: 'continuous',
            frameRate: {
              min: 16,
              max: 16
            },

            mandatory: {
              minWidth: 1280,
              maxWidth: 1280,
              minHeight: 720,
              maxHeight: 720,
              /*minFrameRate: 16,
              maxFrameRate: 16,
              echoCancellation: false, // disabling audio processing
              googAutoGainControl: true,
              googNoiseSuppression: true,
              googHighpassFilter: true,
              googTypingNoiseDetection: true,*/
              //minAspectRatio: 1.77 // test
            },

            // [QVGA]
            // width: {exact: 320}, height: {exact: 240},
            // [VGA]
            //width: this.getMediaSize().width // 2020.03.27 mwj204
            //width: {exact: 1280}, height: {exact: 720},
          }
        }
        // pcConfig: {
        //   iceServers: [
        //     { urls: Ice.stuns }
        //   ]
        // }
        // rtcOfferConstraints: {
        //   offerToReceiveAudio: 1,
        //   offerToReceiveVideo: 1
        // }
      };
      
      console.log(`sip:${this.sip_id}@${process.env.VUE_APP_SIP_SERVER} ==> sip:${this.agentId}@${process.env.VUE_APP_SIP_SERVER}`)
      var session = this.ua.call(`sip:${this.agentId}@${process.env.VUE_APP_SIP_SERVER}`, options);
      this.session = session

      session.on('connecting', () => {
        this.loadingMessage = '상담원에게 연결 중 입니다'
        console.log('[connecting...]')
        window.localv = this.$refs.localv

        this.$refs.localv.srcObject = session._localMediaStream
        let videoTracks = session._localMediaStream.getVideoTracks()

        this.mediaInfo = videoTracks[0].getSettings()
        this.capabilities = videoTracks[0].getCapabilities()
        this.videoTrack = videoTracks[0]

        session.connection.addEventListener('track', (event) => {
          console.log('peerconnection "track" event')
          this.handleRemoteStream(event.streams[0])
        })

        //session.connection.mediaConstraints.video.mandatory.maxFrameRate = 12;

        this.videoTrack.addEventListener('mute', () => { console.log('[track => mute]') })
        this.videoTrack.addEventListener('unmute', () => { console.log('[track => unmute]') })

        // All RTCPeerConnection Events
        // session.connection.addEventListener('connectionstatechange', (evt) => { console.log('connectionstatechange'); console.log(evt) })
        // session.connection.addEventListener('datachannel', (evt) => { console.log('datachannel'); console.log(evt) })
        // session.connection.addEventListener('icecandidate', (evt) => { console.log('icecandidate'); console.log(evt) })
        // session.connection.addEventListener('icecandidateerror', (evt) => { console.log('icecandidateerror'); console.log(evt) })
        // session.connection.addEventListener('iceconnectionstatechange', (evt) => { console.log('iceconnectionstatechange'); console.log(evt) })
        // session.connection.addEventListener('icegatheringstatechange', (evt) => { console.log('icegatheringstatechange'); console.log(evt) })
        // session.connection.addEventListener('isolationchange', (evt) => { console.log('isolationchange'); console.log(evt) })
        // session.connection.addEventListener('negotiationneeded', (evt) => { console.log('negotiationneeded'); console.log(evt) })
        // session.connection.addEventListener('signalingstatechange', (evt) => { console.log('signalingstatechange'); console.log(evt) })
        // session.connection.addEventListener('statsended', (evt) => { console.log('statsended'); console.log(evt) })

        // All Video Element Events
        // this.$refs.localv.addEventListener('abort', (evt) => { console.log('abort'); console.log(evt) })
        // this.$refs.localv.addEventListener('canplay', (evt) => { console.log('VIDEO EL: canplay'); console.log(evt) })
        // this.$refs.localv.addEventListener('canplaythrough', (evt) => { console.log('canplaythrough'); console.log(evt) })
        // this.$refs.localv.addEventListener('emptied', (evt) => { console.log('emptied'); console.log(evt) })
        // this.$refs.localv.addEventListener('ended', (evt) => { console.log('ended'); console.log(evt) })
        // this.$refs.localv.addEventListener('error', (evt) => { console.log('error'); console.log(evt) })
        // this.$refs.localv.addEventListener('interruptbegin', (evt) => { console.log('interruptbegin'); console.log(evt) })
        // this.$refs.localv.addEventListener('interruptend', (evt) => { console.log('interruptend'); console.log(evt) })
        this.$refs.localv.addEventListener('loadeddata', (evt) => {
          console.log('VIDEO EL: loadeddata');
          this.videoResizeHandler()
        })
        // this.$refs.localv.addEventListener('loadedmetadata', (evt) => { console.log('VIDEO EL: loadedmetadata'); console.log(evt) })
        // this.$refs.localv.addEventListener('loadstart', (evt) => { console.log('loadstart'); console.log(evt) })
        // this.$refs.localv.addEventListener('pause', (evt) => { console.log('pause'); console.log(evt) })
        // this.$refs.localv.addEventListener('play', (evt) => { console.log('play'); console.log(evt) })
        // this.$refs.localv.addEventListener('stalled', (evt) => { console.log('stalled'); console.log(evt) })
        // this.$refs.localv.addEventListener('suspend', (evt) => { console.log('suspend'); console.log(evt) })
        // this.$refs.localv.addEventListener('waiting', (evt) => { console.log('waiting'); console.log(evt) })
        
      });

      session.on('progress', () => {
        this.loadingMessage = '영상 스트림을 준비 중 입니다'
        console.log('[progress]');
      });

      session.on('confirmed', () => {
        console.log('[confirmed]');
        let videoDevices = { front: [], back: [] }
        navigator.mediaDevices.enumerateDevices()
          .then((tdevs) => {
            for (let d of tdevs) {
              if (d.kind === 'audioinput') continue;
              if (/front|전면/.test(d.label)) videoDevices.front.unshift(d)
              else if (/back|후면/.test(d.label)) videoDevices.back.unshift(d)
              else console.log(d.label)
            }

            videoDevices.front.sort((a, b) => {return a.label < b.label ? -1 : a.label > b.label ? 1 : 0})
            videoDevices.back.sort((a, b) => {return a.label < b.label ? -1 : a.label > b.label ? 1 : 0})

            this.cameras = videoDevices
            this.camera.front = videoDevices.front[0].deviceId
            this.camera.back = videoDevices.back[0].deviceId

            this.setUserMedia()
          })
          .catch ((e) => console.error(e))
      });

      session.on('sdp', (data) => {
        //let bandWidth = 250
        let bandWidth = 1000
        console.log('[SDP]')
        console.log(`${this.$ua.browser.name}`) // chrome || firefox 64

        let sender = this.session.connection.getSenders()[0]
        let parameters = sender.getParameters()

        if (!parameters.encodings) parameters.encodings = [{}]
        parameters.encodings[0].maxBitrate = bandWidth * 1000
        parameters.encodings[0].bandWidth = bandWidth * 1000; // 2020.03.27 mwj204
        sender.setParameters(parameters)
            .then(() => console.log(`[SET BANDWIDTH: ${bandWidth}]`))
            .catch(e => console.error(e));
        
      })

      session.on('failed', (data) => {
        console.log('[failed]');
        console.log(data);

        let message = ''

        // BYE CANCELED NO_ANSWER EXPIRES NO_ACK DIALOG_ERROR USER_DENIED_MEDIA_ACCESS BAD_MEDIA_DESCRIPTION RTP_TIMEOUT
        switch (data.cause) {
          case JsSIP.C.causes.USER_DENIED_MEDIA_ACCESS: {
            message = '고객님의 카메라/마이크에 접근할 수 없습니다'
            break;
          }
          case JsSIP.C.causes.NO_ANSWER: {
            message = '화상서버에 응답이 없습니다'
            break;
          }
          case JsSIP.C.causes.CANCELED: {
            message = '연결 요청이 취소되었습니다'
            break;
          }
          case JsSIP.C.causes.RTP_TIMEOUT: {
            message = '연결 요청 시간이 초과되었습니다'
            break;
          }
          default: {
            message = '영상상담 요청중 문제가 발생하였습니다'
          }
        }
        this.exitProgress(message)
      })

      session.on('ended', () => {
        console.log('[ended]');
        // this.$appState.$emit('session-close', this.session)
      })

      session.on('accepted', () => {
        console.log('[accepted]');
        this.loading = false
        this.$refs.drawboard.setVideo(this.$refs.localv)
      })

      return;
    },
    handleRemoteStream (stream) {
      console.log('[HANDLE REMOTE STREAM]')
      // console.log(stream)

      let remoteVideo = this.$refs.remotev
      remoteVideo.srcObject = stream

      stream.addEventListener('addtrack', (event) => {
        const track = event.track;
        if (remoteVideo.srcObject === stream) return;
        console.log('[REMOTE STREAM TRACK ADDED]')
        remoteVideo.srcObject = stream;
        track.addEventListener('ended', () => {
          console.log('[REMOTE STREAM TRACK ENDED]');
        });
      });

      stream.addEventListener('removetrack', () => {
        if (remoteVideo.srcObject !== stream) return;
        console.log('[REMOTE STREAM TRACK REMOVED]');
        remoteVideo.srcObject = stream;
      });
    },
    setDirection (data) {
      if (this.direction.timer) clearTimeout(this.direction.timer)
      this.direction.image = Dir[Dir.names[data]]
      this.direction.show = true
      this.direction.timer = setTimeout(() => {
        this.direction.show = false
        this.direction.image = null
        this.direction.timer = null
      }, 5000)
    },
    onBeforeUnloadHandler (evt) {
      evt.preventDefault()
      evt.returnValue = '현재 세션은 종료됩니다'
    },
    exitProgress (message) {
      if (this.loading) this.loadingMessage = message
      else this.$toasted.error(message)
      setTimeout(() => {
        window.removeEventListener("beforeunload", this.onBeforeUnloadHandler)
        return window.location.href = process.env.BASE_URL
      }, 5 * 1000)
    },
    async setUserMedia (cb) {
      try {
        // this.$refs.localv.pause()
        let senders = this.session.connection.getSenders()
        let videoSenders = []
        for (let sender of senders) {
          if (sender.track.kind === 'video') {
            videoSenders.push(sender)
            sender.track.stop()
            console.log(`[TRACK ${sender.track.kind} ${sender.track.label} STOPED]`)
          }
        }
        console.log(`[FACINGMODE: ${this.facingMode}]`)
        let deviceId = this.facingMode === 'user' ? this.camera.front : this.camera.back

        let stream = await navigator.mediaDevices.getUserMedia({video: {deviceId}})
        let tracks = stream.getTracks().filter(v => v.kind === 'video')
        console.log(`[NEW VIDEO TRACKS: ${tracks[0].label}]`)

        videoSenders[0].replaceTrack(tracks[0])
        this.session.renegotiate({useUpdate: true}, () => {
          this.session._localMediaStream = stream
          this.$refs.localv.srcObject = stream
          window.lv = this.$refs.localv
          if (typeof cb === 'function') cb()
          console.log(`[RE-NEGOTIATED]`)

          let videoTracks = stream.getVideoTracks()
          this.mediaInfo = videoTracks[0].getSettings()
          this.capabilities = videoTracks[0].getCapabilities()
          this.videoTrack = videoTracks[0]
        })
        return;
      }
      catch (e) {
        console.log(e)
        this.$toasted.error('카메라 권한을 가져오는데 실패했습니다')
        throw e
      }
    },
    switchCamera (data) {
        try {
          this.facingMode = this.facingMode === 'user' ? 'environment' : 'user'
          if(this.facingMode === 'user') {
            this.currentCarmeraId = this.frontCameraId; 
          }else {
            this.currentCarmeraId = this.backCameraId;
          }
          this.orientationChangeHander();
          this.owt_unPublish();
          this.owt_publish();
          
          /*await this.setUserMedia(() => {
            console.log(`[SWITCH_CAMERA_ACK: ${data}]`)
            this.$client.send({
              kind: 'ap2p',
              cmd: 17, // SWITCH_CAMERA_ACK
              data: data
            })
          })*/
          return;
        }
        catch (e) {
          console.log(e)
          this.$toasted.error('이 브라우저는 카메라 전환 제어를 허용하지 않습니다')
        }
    },
    setVMode () {
      // let vRatio = this.mediaInfo.aspectRatio // this.$refs.localv.clientWidth / this.$refs.localv.clientHeight
      let vRatio = this.$refs.localv.videoWidth / this.$refs.localv.videoHeight
      let dRatio = window.innerWidth / window.innerHeight
      console.log(`${vRatio} : ${dRatio}`)
      console.log(`window: w ${window.innerWidth} h ${window.innerHeight}, video: w ${this.$refs.localv.clientWidth} h ${this.$refs.localv.clientHeight}`)
      this.vmode = (dRatio < vRatio ? 'hori' : 'vert')
      this.$refs.drawboard.setVMode(this.vmode)
    },
    videoResizeHandler () {
      if (this.loading) return;
      this.$nextTick(() => {
        this.$refs.drawboard.calcSize()
        this.setVMode()
      })
    },
    debugLog (msg) {
      console.log(`%c<${msg.cmd} ${JSON.stringify(msg.data)}>`, 'color:#C64B27')
    },
    videoMute (value) {
      console.log(`[VIDEO_MUTE: ${value}]`)
      /*if (value) this.session.mute({audio: true, video: true})
      else this.session.unmute({audio: true, video: true})
      // this.$toasted.success('상담이 일시정지 됬습니다', {icon: {name: 'mdi-information-outline'}})

      this.muted = value
      this.$client.send({
        kind: 'ap2p',
        cmd: 11, // VIDEO_MUTE_ACK
        data: value ? 1 : 0
      })*/

      if (value) {
        this.videoTrack.enabled = false;
        this.$toasted.success('화면전송이 일시정지 되었습니다', {icon: {name: 'mdi-information-outline'}})
      }
      else {
        this.videoTrack.enabled = true;
        this.$toasted.success('화면전송이 시작 되었습니다.', {icon: {name: 'mdi-information-outline'}})
      }
      this.muted = value
    
      this.owt_sendData({
        kind: 'ap2p',
        cmd: 11, // VIDEO_MUTE_ACK
        data: value ? 1 : 0
      })
      return;
    },
    audioMute (value) {
      this.audioMuted = value
      /*this.$client.send({
        kind: 'ap2p',
        cmd: 31, // AUDIO_MUTE_ACK
        data: value ? 1 : 0
      })*/
      this.owt_sendData({
        kind: 'ap2p',
        cmd: 31, // AUDIO_MUTE_ACK
        data: value ? 1 : 0
      })

    },
    sendLocation () {
      navigator.geolocation.getCurrentPosition(
        position => {
          let sendText = `위도: ${position.coords.latitude} <br>`
          sendText += `경도: ${position.coords.longitude} <br>`
          if (position.coords.accuracy) sendText += `오차범위: ${position.coords.accuracy}미터 <br>`
          sendText += `<a target="_blank" href="https://www.google.com/maps/search/?api=1&query=${position.coords.latitude},${position.coords.longitude}" style="color:blue">지도로 보기</a>`
          this.$client.geolocation = position
          this.$toasted.success(`위도: ${position.coords.latitude}, 경도: ${position.coords.longitude}`, {icon: {name: 'mdi-map'}})
          /*this.$client.send({
            kind: 'ap2p',
            cmd: 22, // GUIDE_CHAT
            data: sendText
          })*/
          this.owt_sendData({
            kind: 'ap2p',
            cmd: 22, // GUIDE_CHAT
            data: sendText
          })

          /*this.$client.send({
            kind: 'ap2p',
            cmd: 34, // REQUEST MAP ACK - END
            data: 0
          })*/
          /*this.owt_sendData({
            kind: 'ap2p',
            cmd: 34, // REQUEST MAP ACK - END
            data: 0
          })*/
        },
        err => {
          console.error(err)
          this.$toasted.error('위치정보 접근 권한을 허용하지 않았습니다', {icon: {name: 'mdi-close-outline'}})
        }
      )
    },
    exitDialogSubmitHandler () {
      this.owt_sendData({
        kind: 'ap2p',
        cmd: 3, // STOP_VIDEO_ACK
        data: 0
      })
      this.owt_sendData({
        kind: 'ap2p',
        cmd: 37 // CLIENT_END
      })
      this.owt_unPublish();
      this.owt_stop(); 

      this.exitDialog = false
      this.loadingMessage = '상담을 종료하고 있습니다.'
      this.loading = true
      
      this.closeDialog = null

      // Intel WebRTC
      window.removeEventListener("beforeunload", this.onBeforeUnloadHandler)
      window.location.href = process.env.BASE_URL

      /*this.$client.send({
        kind: 'ap2p',
        cmd: 3, // STOP_VIDEO_ACK
        data: 0
      })
      this.$client.send({
        kind: 'ap2p',
        cmd: 37 // CLIENT_END
      })
      this.$client.close()*/
      
    },
    closeApp () {
      this.exitDialog = true
      // if (this.closeDialog) return;
      // let options = {
      //   duration: false,
      //   singleton: true,
      //   icon: {
      //     name: 'mdi-exit-run'
      //   },
      //   action: [
      //     {
      //       text: '종료',
      //       onClick: () => {
      //         this.closeDialog = null
      //         this.$client.send({
      //           kind: 'ap2p',
      //           cmd: 3, // STOP_VIDEO_ACK
      //           data: 0
      //         })
      //         this.$client.send({
      //           kind: 'ap2p',
      //           cmd: 37 // CLIENT_END
      //         })
      //         this.$client.close()
      //       }
      //     },
      //     {
      //       text: '취소',
      //       onClick: (e, api) => {
      //         this.closeDialog = null
      //         api.goAway(0)
      //       }
      //     }
      //   ]
      // }
      // this.closeDialog = this.$toasted.error('상담을 종료하시겠습니까?', options)
    },
    async scanCode () {
      console.log(`[SCAN TOGGLE: ${this.onScan}]`)
      if (this.onScan) {
        if (this.scanDialog) {
          this.scanDialog.goAway(0)
          this.scanDialog = null
        }
        this.onScan = false
        this.$codeReader.reset()
        //this.$refs.localv.srcObject = this.session._localMediaStream
        this.$refs.localv.srcObject = this.localStream.mediaStream
        if (this.$refs.localv.paused) this.$refs.localv.play()
        /*this.$client.send({
          kind: 'ap2p',
          cmd: 35, // REQUEST SCAN ACK - END
          data: 0
        })*/
        this.owt_sendData({
          kind: 'ap2p',
          cmd: 35, // REQUEST SCAN ACK - END
          data: 0
        })
        return;
      }
      else {
        // let dataUrl = this.$refs.drawboard.getSnapshot()
        // console.log(`[START SCAN BARCODE ${dataUrl.length}]`)
        try {
          // let result = await this.$codeReader.decodeFromImageUrl(dataUrl)
          // let result = await this.$codeReader.decodeFromVideoElement(this.$refs.localv)
          // let result = await this.$codeReader.decodeOnceFromStream(stream, this.$refs.readerv)

          /*this.$client.send({
            kind: 'ap2p',
            cmd: 35, // REQUEST SCAN ACK - START
            data: 1
          })*/
          this.owt_sendData({
            kind: 'ap2p',
            cmd: 35, // REQUEST SCAN ACK - START
            data: 1
          })

          this.onScan = true
          if (!this.scanDialog) {
            this.scanDialog = this.$toasted.info('QR코드나 바코드를 인식해 주세요', {duration: null})
          }

          this.$refs.localv.pause()
          //let stream = this.session._localMediaStream.clone()
          let stream = this.localStream.mediaStream.clone()
          let result = await this.$codeReader.decodeOnceFromStream(stream, this.$refs.readerv)
          let iconName = result.format === 11 ? 'mdi-qrcode' : 'mdi-barcode'
          this.$toasted.success('바코드를 전송했습니다', {icon:{name: iconName}})
          /*this.$client.send({
            kind: 'ap2p',
            cmd: 22, // GUIDE_CHAT
            data: `[BARCODE]<br>타입: ${BarcodeFormats[result.format]}<br>코드: ${result.text}`
          })*/
          this.owt_sendData({
            kind: 'ap2p',
            cmd: 22, // GUIDE_CHAT
            data: `[BARCODE]<br>타입: ${BarcodeFormats[result.format]}<br>코드: ${result.text}`
          })
        }
        catch (e) {
          console.error(e)
          if (this.onScan) {
            this.$toasted.error('바코드/QR코드를 인식하지 못했습니다')
          }
        }
        finally {
          if (this.onScan) {
            if (this.scanDialog) {
              this.scanDialog.goAway(0)
              this.scanDialog = null
            }
            this.onScan = false
            this.$codeReader.reset()
            //this.$refs.localv.srcObject = this.session._localMediaStream
            this.$refs.localv.srcObject = this.localStream.mediaStream
            if (this.$refs.localv.paused) this.$refs.localv.play()

            /*this.$client.send({
              kind: 'ap2p',
              cmd: 35, // REQUEST SCAN ACK - END
              data: 0
            })*/
            /*this.owt_sendData({
              kind: 'ap2p',
              cmd: 35, // REQUEST SCAN ACK - END
              data: 0
            })*/
          }
        }
      }
      return;
    },
    async toggleTorch (value) {
      console.log(`[TOGGLE TORCH: ${value}]`)
      if (!supports['torch']) return this.$toasted.error('이 브라우저는 플래시 제어를 허용하지 않습니다', {icon: {name: 'mdi-alert'}})
      try {
        await this.videoTrack.applyConstraints({ advanced: [{torch: value}] })
        this.torch = value
        /*this.$client.send({
          kind: 'ap2p',
          cmd: 7, // FLASH_ACK
          data: value ? 1 : 0
        })*/
        this.owt_sendData({
          kind: 'ap2p',
          cmd: 7, // FLASH_ACK
          data: value ? 1 : 0
        })
      }
      catch (e) {
        console.error(e)
        this.$toasted.error('이 브라우저는 플래시 제어를 허용하지 않습니다', {icon: {name: 'mdi-alert'}})
        /*this.$client.send({
          kind: 'ap2p',
          cmd: 7, // FLASH_ACK
          data: this.torch ? 1 : 0
        })*/
        this.owt_sendData({
          kind: 'ap2p',
          cmd: 7, // FLASH_ACK
          data: this.torch ? 1 : 0
        })
      }
      return;
    },
    orientationChangeHander () {
      //nbh
      var utilBot = document.getElementById('util')
      if (this.$ua.os.name === 'iOS'){
        if(this.facingMode === 'environment'){
          this.angle = 90 - window.orientation
          if(this.angle == 90){
            utilBot.style.bottom = '32px'
          }else{
            utilBot.style.bottom = '15px'
          }
        }else{
          if(window.orientation === 0){
            this.angle = -90
            utilBot.style.bottom = '32px'
          }
          if(window.orientation === 90){
            this.angle = 180
            utilBot.style.bottom = '15px'
          }
          if(window.orientation === -90){
            this.angle = 0
            utilBot.style.bottom = '15px'
          }
        }
      }
      
    },
    getMediaSize (p) {
      let size = this.qualities[1]
      let result = null
      if (typeof p === 'number' && this.qualities[p]) size = this.qualities[p]
      // if (window.orientation === 0 || window.orientation === 180) result = { width: {exact: size[1]}, height: {exact: size[0]} }
      // else result = { width: {exact: size[0]}, height: {exact: size[1]} }

      //result = { width: {exact: size[0]}, height: {exact: size[1]} } // 2020.03.07
      result = { width: {exact: 1280}, height: 720 }
      console.log(result)
      return result
    }
  },
  beforeDestroy () {
    this.$client.$off('control')
    window.removeEventListener('resize', this.videoResizeHandler)
    document.body.onorientationchange = null
  },
  mounted () {
     require('./owt.js')
     require('./sc.websocket.js')

    if (!this.$route.params.fromHome) return window.location.href = process.env.BASE_URL
    window.addEventListener("beforeunload", this.onBeforeUnloadHandler)
    if (this.$ua.os.name === 'iOS') {
      document.body.onorientationchange = this.orientationChangeHander.bind(this)
      this.orientationChangeHander()
    }

    this.$client.$on('terminate', () => {
      window.removeEventListener("beforeunload", this.onBeforeUnloadHandler)
      window.location.href = process.env.BASE_URL
    })

    window.addEventListener('resize', this.videoResizeHandler)

    this.$client.$on('control', (data) => {
      console.log(`[AP2P CONTROL ${data.cmd}]`)
      switch (data.cmd) {
        case -1: {
          try {
            this.session.terminate()
            this.ua.unregister()
          }
          catch (e) {
            console.error(e)
          }
          this.$client.close()
          break;
        }
        case 0: { // START_VIDEO
          this.sip_id = this.$client.servernum + 'c'
          this.agentId = this.$client.servernum + 'a'
          //this.connect()
          
          console.log('START_VIDEO id : ' + this.owt_Uid + this.owt_remoteUid)
          this.owt_connect();

          this.$client.send({
            kind: 'ap2p',
            cmd: 1, // START_VIDEO_ACK
            data: 0
          })
          break;
        }
        case 2: // STOP VIDEO
          break;
        case 4: { // FOCUS
          this.$toasted.success('포커스를 재조정 중입니다', {icon: {name: 'mdi-information-outline'}})
          break;
        }
        case 6: { // FLASH
          this.toggleTorch(Boolean(data.data))
          break;
        }
        case 8: { // START / STOP DRAWBOARD
          if (this.$refs.drawboard) {
            this.$refs.drawboard.clear()
          }
          break;
        }
        case 10: { // VIDEO MUTE (PAUSE)
          this.videoMute(Boolean(data.data))
          break;
        }
        case 14: { // AGENT_SHOW
          if (data.data === 1) this.remoteVideoEnable = true
          else this.remoteVideoEnable = false
          this.$client.send({
            kind: 'ap2p',
            cmd: 15, // AGENT_SHOW_ACK
            data: data.data
          })
          break;
        }
        case 16: { // FACINGMODE SWITCH
          this.switchCamera(data.data)
          break;
        }
        case 18: { // GUIDE_IMAGE
          this.setDirection(data.data)
          break;
        }
        case 20: { // DRAWBOARD DATA
          // this.debugLog(data)
          if (this.$refs.drawboard) {
            this.$refs.drawboard.draw(data.data)
          }
          break;
        }
        case 22: { // GUIDE_CHAT
          this.$toasted.info(data.data, {icon: {name: 'mdi-chat-processing'}})
          break;
        }
        case 24: { // SET QUALITY
          let p = parseInt(data.data, 10)
          // 0 저화질, 1 중화질 2고화질
          
          this.debugLog(data)
          this.owt_unPublish(data.data)
          if(p == 0){
            this.owt_publish(320,240)
          }
          if(p == 1){
            this.owt_publish(640,480)
          }
          if(p == 2){
             //this.owt_publish(1280,720)
             this.owt_publish(1280,960)
            //this.owt_publish(960,640)
          }
          // if (!supports['frameRate']) return this.$toasted.error('이 브라우저는 품질 전환 제어를 허용하지 않습니다', {icon: {name: 'mdi-alert'}})
          /*this.$refs.localv.pause()
          this.$refs.localv.srcObject = null
          let p = parseInt(data.data, 10)
          this.videoTrack.applyConstraints(this.getMediaSize(p))
            .then(() => {
              setTimeout(() => {
                //this.$refs.localv.srcObject = this.session._localMediaStream
                this.$refs.localv.srcObject = this.localStream.mediaStream
                this.$refs.localv.load()
              }, 1000)
              
              this.$client.send({
                kind: 'ap2p',
                cmd: 25, // SET QUALITY_ACK
                data: data.data
              })
            })
            .catch(e => {
              console.error(e)
              this.$toasted.error('이 브라우저는 품질 전환 제어를 허용하지 않습니다 ', {icon: {name: 'mdi-alert'}})
            })*/
            this.$client.send({
              kind: 'ap2p',
              cmd: 25, // SET QUALITY_ACK
              data: data.data
            })
          break;
        }
        case 28: { // VIDEO_RECODING
          this.onRecord = Boolean(data.data)
          this.$client.send({
            kind: 'ap2p',
            cmd: 29, // VIDEO_RECODING_ACK
            data: data.data
          })
          break;
        }
        case 30: { // SPEAKER PHONE
          this.audioMute(Boolean(data.data))
          break;
        }
        case 33: { // REQUEST MAP FROM AGENT
          this.sendLocation()
          break;
        }
        case 34: { // REQUEST SCAN FROM AGENT
          this.scanCode()
          break;
        }
        case 1000: { // WS SERVER START SIGN (DISABLED)
          // this.sip_id = this.$client.servernum + 'c'
          // this.agentId = this.$client.servernum + 'a'
          // this.connect()
          break;
        }
        default: {
          this.$toasted.error(`CMD ${data.cmd} DATA ${JSON.stringify(data.data)}`)
          console.log(`[UNKNOWN AP2P MESSAGE ${data.cmd}]`)
        }
      }
    })
    this.owt_init();
    this.owt_initcamera();
    //this.owt_connect();
    //this.owt_publish();
  },
  data () {
    return {
      signalingConnect: false,
      loading: true,
      loadingMessage: '화상 서버 정보를 받아오고 있습니다',
      ua: null,
      session: null,
      peer: null,
      agentId: null,
      muted: false,
      audioMuted: false,
      direction: {
        show: false,
        image: null,
        timer: null
      },
      videoTrack: null,
      mediaInfo: null,
      vmode: 'vert',
      torch: false,
      onRecord: false,
      onScan: false,
      facingMode: 'environment',
      cameras: null,
      camera: {
        front: null,
        back: null
      },
      qualitiesA: [
        { width: {exact: 320}, height: {exact: 240} },
        { width: {exact: 640}, height: {exact: 480} },
        { width: {exact: 1280}, height: {exact: 720} }
      ],
      qualities: [
        [320, 240],
        [640, 480],
        [1280, 720]
      ],
      remoteVideoEnable: false,
      closeDialog: null,
      scanDialog: null,
      exitDialog: false,
      angle: null,
      owt_p2p : null,
      owt_Uid : null, 
      owt_remoteUid : null
    }
  }
}
</script>

<style lang="scss" scoped>
  video {
    &.hori { width: calc(100vw - 20px) }
    &.vert { height: calc(100vh - 50px) }
  }
  body {
    background-color: #00284c;
  }
  .video-chat-container {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: #00284c;
    .video-chat-wait {
      display: block;
      text-align: center;
    }
    .video-chat-focusarea {
      position: absolute;
      top: 0; bottom: 0; left: 0; right: 0;
      z-index: 90;
      display: flex;
      align-items: center;
      justify-content: center;
      .video-chat-focusarea-box {
        width: 70%; min-width: 320px;
        height: 50%; max-height: 240px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 4px solid white;
        background-color: rgba(0,0,0,0.2);
        border-radius: 10px;
      }
      .video-chat-focusarea-text {
        color: white;
        font-size: 16px;
        font-weight: bold;
        animation: blinker 1s linear infinite;
      }
    }
    .video-chat-direction {
      position: absolute;
      top: 0; bottom: 0; left: 0; right: 0;
      z-index: 100;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      img {
        display: block;
        padding: 10px;
        border-radius: 5px;
        background-color: rgba(255,255,255,0.4);
        animation: blinker 1s linear infinite;
      }
    }
    .video-chat-online {
      position: relative;
      display: none;
    }
    .video-remote {
      position: absolute;
      top: 4px; left: 4px;
      width: 180px;
      border-radius:8px;
      border:solid 2px #fff;
      box-shadow:4px 4px 4px rgba(0,0,0,0.5);
      z-index: 100;
    }
    .video-reader {
      // position: absolute;
      display: none;
      &.on-scan { display: block; }
    }
    &.connected {
      .video-chat-wait { display: none; }
      .video-chat-online { display: block; }
      .utilities { display: flex; }
    }

    .utilities {
      position: absolute;
      bottom: 15px; left: 10px; right: 10px;//bottom15px
      justify-content: space-between;
      align-items: center;
      z-index: 100;
      display: none;
      background-color: #00284c;
      border-radius: 5px;

      .ut-btn {
        color: white;
        font-size: 30px;
        border: 0;
        background-color: transparent;  
        width: 35px; height: 35px;
        padding: 0; margin: 3px;
        outline: none;
      }

      .on-record {
        display: inline-block;
        color: red;
        font-size: 30px;
        animation: blinker 1s linear infinite;
      }
    }
    .fs_nbh {
    position: absolute;
    z-index: 100;
    top: 15px;
    right: 15px;
    color: #fff;
    font-size: 30px;
    border: 0;
    background-color: transparent;
    width: 35px;
    height: 35px;
    padding: 0;
    margin: 3px;
    outline: none
    }
  }

  .ios-dir-assist {
    position: fixed;
    top: 0; bottom: 0; left: 0; right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 90;

    .mdi {
      font-size: 64px;
      transition: transform 0.8s;
    }

    .ios-dir-assist-box {
      width: 180px; height: 180px;
      background-color: rgba(0,0,0,0.8);
      border-radius: 10px;
      color: white;
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
  }

  @keyframes blinker {
    50% {
      opacity: 0.5;
    }
  }
</style>